module.exports = __webpack_public_path__ + "media/app-store-detail/window-ef32bc08.svg";